// extracted by mini-css-extract-plugin
export default {"themeToggle":"theme-toggle_themeToggle__o2BLz"};